export const LANGUAGES = [
    { code: "it", label: "IT", name: "Italiano" },
    { code: "en", label: "EN", name: "English" },
    { code: "es", label: "ES", name: "Español" },
    { code: "fr", label: "FR", name: "Français" },
    { code: "de", label: "DE", name: "Deutsch" },
];

/* eslint-disable */
export const translations = {
    it: {
        nav: {
            manifesto: "Manifesto",
            rete: "La Rete",
            comeFunziona: "Come Funziona",
            codici: "Codici",
            faq: "FAQ",
            cta: "Lista d'attesa",
            language: "Lingua",
        },
        hero: {
            eyebrow: "La rete civica intelligente",
            headline_1: "The Good",
            headline_2a: "Big",
            headline_2b: "Brother",
            headline_3a: "is",
            headline_3b: "You.",
            subtitle:
                "La prima rete sociale civica. Segnala, appoggia, ricondividi. Un'IA ti stima norma violata e danni; ricevi notifiche quando succede vicino a te. Ogni contributo verificato ti fa salire di livello.",
            ctaPrimary: "Unisciti alla lista d'attesa",
            ctaSecondary: "Scopri come funziona",
            liveNorm: "LIVE — Norme aggiornate",
            comingStores: "Coming Soon · iOS & Android",
            scroll: "Scorri",
            target: "+ Target",
            shieldId: "SHIELD 001",
        },
        trust: {
            label: "Una rete civica, un'unica app —",
            items: ["Feed live", "IA · Stima danni", "Notifiche geo", "Punteggio & livelli", "Codici in vigore"],
        },
        marquee: ["Il buon cittadino", "è la rete", "The good big brother is you", "Sentinel"],
        manifesto: {
            eyebrow: "Manifesto",
            count: "Sei principi",
            chapterLabel: "Capitolo",
            chapters: [
                { title: "Osserva", text: "Ogni cittadino è il primo presidio del territorio. Riconosci un'infrazione e acquisisci consapevolezza dello spazio che ti circonda." },
                { title: "Segnala", text: "Foto, video, GPS: la tua segnalazione entra in un feed live, visibile a tutta la rete civica." },
                { title: "Analizza", text: "L'IA di Sentinel individua la norma esatta violata e stima automaticamente i danni economici." },
                { title: "Condividi", text: "La community discute, appoggia, ricondivide. La responsabilità civile diventa un fatto collettivo." },
                { title: "Cresci", text: "Ogni contributo verificato ti fa salire di livello: da Osservatore a Guardiano, fino a Sentinella." },
                { title: "Educa", text: "Non è distopia, è responsabilizzazione. Sorveglianza etica dal basso, trasparente e guidata dai cittadini." },
            ],
        },
        civic: {
            eyebrow: "La Rete",
            tagline: "Social · Civica · Verificata",
            headline_a: "Non un'app. Una",
            headline_b: "rete",
            headline_c: "di responsabilità civile.",
            body_a: "Sentinel è la prima",
            body_b: "rete sociale civica",
            body_c: ": un feed live dove i cittadini segnalano, appoggiano e discutono ciò che accade nel loro territorio. Ricevi",
            body_d: "notifiche geografiche",
            body_e: "quando succede qualcosa vicino a te. Ogni contributo verificato ti fa crescere di livello — dall'Osservatore fino alla",
            body_f: "Sentinella",
            levelsTitle: "I livelli della rete",
            stats: [
                { k: "Appoggi", v: "1.2k" },
                { k: "Discussioni", v: "384" },
                { k: "Ricondivise", v: "526" },
                { k: "Notifiche geo", v: "12/h" },
            ],
            levels: [
                { n: "Lv1", title: "Osservatore", desc: "I tuoi primi occhi sul territorio." },
                { n: "Lv2", title: "Cittadino", desc: "Segnalazioni verificate dalla community." },
                { n: "Lv3", title: "Custode", desc: "Contributi ricorrenti, feedback puntuale." },
                { n: "Lv4", title: "Guardiano", desc: "Punto di riferimento del quartiere." },
                { n: "Lv5", title: "Sentinella", desc: "Autorità civica riconosciuta dalla rete." },
            ],
            floatNotifTitle: "Nuova nel quartiere",
            floatNotifText: "Sosta vietata · 120m da te",
            floatNotifLoc: "Roma · Trastevere",
            floatAiTitle: "Analisi AI completata",
            floatAiBadge: "+ 12 pt · Lv4 Guardiano",
        },
        how: {
            eyebrow: "Il flusso",
            count: "Tre passaggi",
            headline_a: "Come funziona",
            headline_b: "Sentinel",
            stepLabel: "Step",
            steps: [
                { title: "Segnala", text: "Foto o video con GPS attivo. Categoria, luogo, descrizione — tutto in pochi secondi." },
                { title: "IA analizza", text: "L'intelligenza artificiale individua la norma esatta e stima i danni economici." },
                { title: "Entra nel feed", text: "La community discute, appoggia e ricondivide. Tu guadagni punti e sali di livello." },
            ],
        },
        features: {
            eyebrow: "Funzionalità",
            count: "Otto pilastri",
            headline_a: "Uno strumento",
            headline_b: "completo",
            items: [
                { title: "Segnala un'infrazione", text: "Foto, video, GPS in un solo tap. La tua segnalazione entra subito nella rete civica." },
                { title: "IA · Norma & Danni", text: "L'intelligenza artificiale individua la norma violata e stima il danno economico." },
                { title: "Notifiche vicino a te", text: "Ti avvisiamo in tempo reale quando succede qualcosa nel tuo quartiere." },
                { title: "Rete sociale civica", text: "Un feed di cittadini: commenta, appoggia, ricondividi. La responsabilità è collettiva." },
                { title: "Punteggio & Livelli", text: "Ogni contributo verificato ti fa crescere: da Osservatore a Guardiano, fino a Sentinella." },
                { title: "Categorie multiple", text: "Traffico, Ambiente, Decoro urbano, Sport, Civile, Penale — tutto in un unico feed." },
                { title: "Geo-normativa", text: "Le regole si adattano al luogo esatto della segnalazione." },
                { title: "Wallet civico", text: "Riscatta i punti guadagnati con la community. Riconoscimenti reali, non solo badge." },
            ],
        },
        coverage: {
            eyebrow: "Copertura",
            count: "Quattro codici",
            headline_a: "Un'unica app per",
            headline_b: "ogni norma",
            previewLabel: "Codice",
            anteprima: "Anteprima",
            items: [
                { name: "STRADALE", example: "Divieti di sosta · Limiti di velocità · Uso del cellulare alla guida" },
                { name: "CIVILE", example: "Danni · Confini · Controversie contrattuali" },
                { name: "PENALE", example: "Reati contro il patrimonio · Ordine pubblico · Persona" },
                { name: "SPORTIVO", example: "Regolamenti federali · Fair play · Infrazioni in campo" },
            ],
        },
        testimonials: {
            eyebrow: "Voci",
            count: "Chi la sta provando",
            quotes: [
                { text: "Uno strumento indispensabile per chi vuole conoscere davvero le regole della propria città.", author: "Marco V.", role: "Automobilista, 42" },
                { text: "Sentinel trasforma ogni cittadino in un custode attivo e consapevole della legalità.", author: "Elena M.", role: "Avvocato civilista, 55" },
                { text: "In campo lo uso per capire subito la gravità dei falli. Un colpo d'occhio e il regolamento è chiaro.", author: "Luca R.", role: "Arbitro dilettante, 27" },
            ],
        },
        faq: {
            eyebrow: "FAQ",
            count: "Domande frequenti",
            headline_a: "Le tue",
            headline_b: "domande",
            headline_c: ", senza giri di parole.",
            items: [
                { q: "L'app sostituisce un avvocato?", a: "No. Sentinel è uno strumento di consapevolezza civica e stima preliminare. Non fornisce consulenza legale ufficiale, ma ti aiuta a capire quale norma potrebbe essere stata violata e l'ordine di grandezza delle sanzioni." },
                { q: "Come vengono calcolate le sanzioni?", a: "L'IA incrocia i dati dell'infrazione segnalata con i codici in vigore (Stradale, Civile, Penale, Sportivo) e con la giurisdizione locale del comune in cui ti trovi." },
                { q: "I miei dati sono privati?", a: "Assolutamente sì. Le segnalazioni sono processate garantendo l'anonimato dell'utente e la privacy by design. Nessun dato personale viene condiviso senza consenso." },
                { q: "Quando sarà disponibile Sentinel?", a: "Stiamo ultimando lo sviluppo delle ultime funzionalità. Iscriviti alla lista d'attesa per essere tra i primi a provarla su iOS e Android." },
                { q: "L'app è gratuita?", a: "Le funzionalità di base per il cittadino saranno sempre gratuite. Sono in valutazione strumenti avanzati (report dettagliati, esportazione) come opzione premium." },
            ],
        },
        finalCta: {
            eyebrow: "Lista d'attesa · Coming Soon",
            headline_a: "Diventa una",
            headline_b: "Sentinella.",
            body: "Sarai tra i primi a provare Sentinel. Nessuno spam, solo un'unica email quando saremo pronti al lancio.",
            placeholder: "Il tuo indirizzo email",
            submit: "Iscriviti",
            submitting: "Attendi…",
            successTitle: "Sei nella lista d'attesa.",
            successBody: "Ti scriveremo appena Sentinel sarà pronto. Benvenuto/a tra le Sentinelle.",
            errorInvalid: "Inserisci un'email valida.",
            liveInfo: "Anteprima disponibile Q1",
            stores: "iOS & Android · Coming Soon",
            noCard: "Nessuna carta richiesta",
        },
        footer: {
            tagline: "The Good Big Brother is You",
            about: "L'assistente civico intelligente. Osserva, analizza, stima. Una rete per il cittadino consapevole, per un'Italia più giusta.",
            navigate: "Naviga",
            coming: "Presto disponibile",
            comingSoon: "Coming Soon",
            rights: "© 2026 Sentinel — Tutti i diritti riservati.",
            made: "Made in Italy · Etica by design",
            top: "Torna su ↑",
        },
    },

    en: {
        nav: {
            manifesto: "Manifesto",
            rete: "The Network",
            comeFunziona: "How It Works",
            codici: "Codes",
            faq: "FAQ",
            cta: "Waitlist",
            language: "Language",
        },
        hero: {
            eyebrow: "The intelligent civic network",
            headline_1: "The Good",
            headline_2a: "Big",
            headline_2b: "Brother",
            headline_3a: "is",
            headline_3b: "You.",
            subtitle:
                "The first civic social network. Report, back, reshare. An AI estimates the violated law and the damages; you get notified when something happens near you. Every verified contribution levels you up.",
            ctaPrimary: "Join the waitlist",
            ctaSecondary: "See how it works",
            liveNorm: "LIVE — Laws up to date",
            comingStores: "Coming Soon · iOS & Android",
            scroll: "Scroll",
            target: "+ Target",
            shieldId: "SHIELD 001",
        },
        trust: {
            label: "One civic network, one app —",
            items: ["Live feed", "AI · Damage estimate", "Geo alerts", "Score & levels", "Laws in force"],
        },
        marquee: ["The good citizen", "is the network", "The good big brother is you", "Sentinel"],
        manifesto: {
            eyebrow: "Manifesto",
            count: "Six principles",
            chapterLabel: "Chapter",
            chapters: [
                { title: "Observe", text: "Every citizen is the first guardian of the territory. Recognise an infraction and become aware of the space around you." },
                { title: "Report", text: "Photo, video, GPS: your report enters a live feed, visible to the entire civic network." },
                { title: "Analyse", text: "Sentinel's AI identifies the exact rule violated and automatically estimates the economic damage." },
                { title: "Share", text: "The community discusses, backs and reshares. Civic responsibility becomes a collective act." },
                { title: "Grow", text: "Every verified contribution levels you up — from Observer to Guardian, all the way to Sentinel." },
                { title: "Educate", text: "It's not dystopia, it's accountability. Ethical bottom-up oversight, transparent and citizen-led." },
            ],
        },
        civic: {
            eyebrow: "The Network",
            tagline: "Social · Civic · Verified",
            headline_a: "Not an app. A",
            headline_b: "network",
            headline_c: "of civic responsibility.",
            body_a: "Sentinel is the first",
            body_b: "civic social network",
            body_c: ": a live feed where citizens report, back and discuss what happens in their territory. You receive",
            body_d: "geographic alerts",
            body_e: "when something happens near you. Every verified contribution levels you up — from Observer to",
            body_f: "Sentinel",
            levelsTitle: "The levels of the network",
            stats: [
                { k: "Backs", v: "1.2k" },
                { k: "Threads", v: "384" },
                { k: "Reshares", v: "526" },
                { k: "Geo alerts", v: "12/h" },
            ],
            levels: [
                { n: "Lv1", title: "Observer", desc: "Your first eyes on the territory." },
                { n: "Lv2", title: "Citizen", desc: "Reports verified by the community." },
                { n: "Lv3", title: "Keeper", desc: "Recurring, on-point contributions." },
                { n: "Lv4", title: "Guardian", desc: "Neighbourhood reference point." },
                { n: "Lv5", title: "Sentinel", desc: "Civic authority recognised by the network." },
            ],
            floatNotifTitle: "New nearby",
            floatNotifText: "No parking · 120m from you",
            floatNotifLoc: "Rome · Trastevere",
            floatAiTitle: "AI analysis complete",
            floatAiBadge: "+ 12 pts · Lv4 Guardian",
        },
        how: {
            eyebrow: "The flow",
            count: "Three steps",
            headline_a: "How",
            headline_b: "Sentinel works",
            stepLabel: "Step",
            steps: [
                { title: "Report", text: "Photo or video with GPS. Category, location, description — all in seconds." },
                { title: "AI analyses", text: "The AI identifies the exact rule and estimates the economic damage." },
                { title: "Enter the feed", text: "The community discusses, backs and reshares. You earn points and level up." },
            ],
        },
        features: {
            eyebrow: "Features",
            count: "Eight pillars",
            headline_a: "One complete",
            headline_b: "tool",
            items: [
                { title: "Report an infraction", text: "Photo, video, GPS in one tap. Your report enters the civic network right away." },
                { title: "AI · Law & Damage", text: "The AI identifies the violated rule and estimates the economic damage." },
                { title: "Alerts nearby", text: "We notify you in real time when something happens in your neighbourhood." },
                { title: "Civic social network", text: "A citizens' feed: comment, back, reshare. Responsibility is collective." },
                { title: "Score & Levels", text: "Every verified contribution grows you: from Observer to Guardian, to Sentinel." },
                { title: "Multiple categories", text: "Traffic, Environment, Public decorum, Sport, Civil, Criminal — one feed." },
                { title: "Geo-legal", text: "Rules adapt to the exact location of the report." },
                { title: "Civic wallet", text: "Redeem points earned with the community. Real recognition, not just badges." },
            ],
        },
        coverage: {
            eyebrow: "Coverage",
            count: "Four codes",
            headline_a: "One app for",
            headline_b: "every law",
            previewLabel: "Code",
            anteprima: "Preview",
            items: [
                { name: "TRAFFIC", example: "No-parking · Speed limits · Phone use while driving" },
                { name: "CIVIL", example: "Damages · Boundaries · Contract disputes" },
                { name: "CRIMINAL", example: "Crimes against property · Public order · Person" },
                { name: "SPORTS", example: "Federal regulations · Fair play · On-field infractions" },
            ],
        },
        testimonials: {
            eyebrow: "Voices",
            count: "Who's using it",
            quotes: [
                { text: "An essential tool for anyone who really wants to know the rules of their city.", author: "Marco V.", role: "Driver, 42" },
                { text: "Sentinel turns every citizen into an active, aware guardian of the law.", author: "Elena M.", role: "Civil lawyer, 55" },
                { text: "On the pitch I use it to instantly grasp the severity of fouls. One glance and the rulebook is clear.", author: "Luca R.", role: "Amateur referee, 27" },
            ],
        },
        faq: {
            eyebrow: "FAQ",
            count: "Frequently asked",
            headline_a: "Your",
            headline_b: "questions",
            headline_c: ", straight to the point.",
            items: [
                { q: "Does the app replace a lawyer?", a: "No. Sentinel is a civic awareness and preliminary estimation tool. It doesn't provide official legal advice, but helps you understand which law may have been violated and the ballpark of the sanctions." },
                { q: "How are sanctions calculated?", a: "The AI cross-references the reported infraction with the codes in force (Traffic, Civil, Criminal, Sports) and the local jurisdiction of your municipality." },
                { q: "Is my data private?", a: "Absolutely. Reports are processed guaranteeing user anonymity and privacy by design. No personal data is shared without consent." },
                { q: "When will Sentinel be available?", a: "We're finishing the last features. Join the waitlist to be among the first to try it on iOS and Android." },
                { q: "Is the app free?", a: "Core features for citizens will always be free. Advanced tools (detailed reports, export) are being evaluated as a premium option." },
            ],
        },
        finalCta: {
            eyebrow: "Waitlist · Coming Soon",
            headline_a: "Become a",
            headline_b: "Sentinel.",
            body: "Be among the first to try Sentinel. No spam, just one email when we're ready to launch.",
            placeholder: "Your email address",
            submit: "Subscribe",
            submitting: "Please wait…",
            successTitle: "You're on the waitlist.",
            successBody: "We'll write as soon as Sentinel is ready. Welcome to the Sentinels.",
            errorInvalid: "Please enter a valid email.",
            liveInfo: "Preview available Q1",
            stores: "iOS & Android · Coming Soon",
            noCard: "No card required",
        },
        footer: {
            tagline: "The Good Big Brother is You",
            about: "The intelligent civic assistant. Observe, analyse, estimate. A network for the aware citizen, for a fairer country.",
            navigate: "Navigate",
            coming: "Coming soon",
            comingSoon: "Coming Soon",
            rights: "© 2026 Sentinel — All rights reserved.",
            made: "Made in Italy · Ethics by design",
            top: "Back to top ↑",
        },
    },

    es: {
        nav: {
            manifesto: "Manifiesto",
            rete: "La Red",
            comeFunziona: "Cómo funciona",
            codici: "Códigos",
            faq: "FAQ",
            cta: "Lista de espera",
            language: "Idioma",
        },
        hero: {
            eyebrow: "La red cívica inteligente",
            headline_1: "The Good",
            headline_2a: "Big",
            headline_2b: "Brother",
            headline_3a: "is",
            headline_3b: "You.",
            subtitle:
                "La primera red social cívica. Denuncia, apoya, recomparte. Una IA estima la norma infringida y los daños; recibes notificaciones cuando ocurre cerca de ti. Cada contribución verificada te hace subir de nivel.",
            ctaPrimary: "Únete a la lista de espera",
            ctaSecondary: "Descubre cómo funciona",
            liveNorm: "LIVE — Normas actualizadas",
            comingStores: "Coming Soon · iOS & Android",
            scroll: "Desliza",
            target: "+ Target",
            shieldId: "SHIELD 001",
        },
        trust: {
            label: "Una red cívica, una única app —",
            items: ["Feed en vivo", "IA · Estimación daños", "Alertas geo", "Puntuación y niveles", "Normativa vigente"],
        },
        marquee: ["El buen ciudadano", "es la red", "The good big brother is you", "Sentinel"],
        manifesto: {
            eyebrow: "Manifiesto",
            count: "Seis principios",
            chapterLabel: "Capítulo",
            chapters: [
                { title: "Observa", text: "Cada ciudadano es el primer guardián del territorio. Reconoce una infracción y toma conciencia del espacio que te rodea." },
                { title: "Denuncia", text: "Foto, vídeo, GPS: tu denuncia entra en un feed en vivo, visible para toda la red cívica." },
                { title: "Analiza", text: "La IA de Sentinel identifica la norma exacta violada y estima automáticamente los daños económicos." },
                { title: "Comparte", text: "La comunidad discute, apoya y recomparte. La responsabilidad cívica se vuelve colectiva." },
                { title: "Crece", text: "Cada contribución verificada te hace subir de nivel: de Observador a Guardián, hasta Centinela." },
                { title: "Educa", text: "No es distopía, es responsabilidad. Vigilancia ética desde abajo, transparente y guiada por los ciudadanos." },
            ],
        },
        civic: {
            eyebrow: "La Red",
            tagline: "Social · Cívica · Verificada",
            headline_a: "No es una app. Es una",
            headline_b: "red",
            headline_c: "de responsabilidad civil.",
            body_a: "Sentinel es la primera",
            body_b: "red social cívica",
            body_c: ": un feed en vivo donde los ciudadanos denuncian, apoyan y discuten lo que sucede en su territorio. Recibes",
            body_d: "alertas geográficas",
            body_e: "cuando ocurre algo cerca de ti. Cada contribución verificada te hace subir de nivel — de Observador hasta",
            body_f: "Centinela",
            levelsTitle: "Los niveles de la red",
            stats: [
                { k: "Apoyos", v: "1.2k" },
                { k: "Debates", v: "384" },
                { k: "Recompartidos", v: "526" },
                { k: "Alertas geo", v: "12/h" },
            ],
            levels: [
                { n: "Lv1", title: "Observador", desc: "Tus primeros ojos sobre el territorio." },
                { n: "Lv2", title: "Ciudadano", desc: "Denuncias verificadas por la comunidad." },
                { n: "Lv3", title: "Custodio", desc: "Contribuciones recurrentes y feedback preciso." },
                { n: "Lv4", title: "Guardián", desc: "Referente del barrio." },
                { n: "Lv5", title: "Centinela", desc: "Autoridad cívica reconocida por la red." },
            ],
            floatNotifTitle: "Nuevo cerca de ti",
            floatNotifText: "Estacionamiento prohibido · 120m",
            floatNotifLoc: "Roma · Trastevere",
            floatAiTitle: "Análisis IA completado",
            floatAiBadge: "+ 12 pt · Lv4 Guardián",
        },
        how: {
            eyebrow: "El flujo",
            count: "Tres pasos",
            headline_a: "Cómo funciona",
            headline_b: "Sentinel",
            stepLabel: "Paso",
            steps: [
                { title: "Denuncia", text: "Foto o vídeo con GPS. Categoría, lugar, descripción — todo en segundos." },
                { title: "La IA analiza", text: "La inteligencia artificial identifica la norma exacta y estima los daños económicos." },
                { title: "Entra en el feed", text: "La comunidad discute, apoya y recomparte. Tú ganas puntos y subes de nivel." },
            ],
        },
        features: {
            eyebrow: "Funcionalidades",
            count: "Ocho pilares",
            headline_a: "Una herramienta",
            headline_b: "completa",
            items: [
                { title: "Denuncia una infracción", text: "Foto, vídeo, GPS en un solo toque. Tu denuncia entra al instante en la red cívica." },
                { title: "IA · Norma y Daños", text: "La IA identifica la norma violada y estima el daño económico." },
                { title: "Alertas cerca de ti", text: "Te avisamos en tiempo real cuando ocurre algo en tu barrio." },
                { title: "Red social cívica", text: "Un feed de ciudadanos: comenta, apoya, recomparte. La responsabilidad es colectiva." },
                { title: "Puntuación y Niveles", text: "Cada contribución verificada te hace crecer: de Observador a Guardián, hasta Centinela." },
                { title: "Categorías múltiples", text: "Tráfico, Ambiente, Ornato urbano, Deporte, Civil, Penal — un solo feed." },
                { title: "Geo-normativa", text: "Las reglas se adaptan al lugar exacto de la denuncia." },
                { title: "Cartera cívica", text: "Canjea los puntos ganados con la comunidad. Reconocimiento real, no solo insignias." },
            ],
        },
        coverage: {
            eyebrow: "Cobertura",
            count: "Cuatro códigos",
            headline_a: "Una app para",
            headline_b: "cada norma",
            previewLabel: "Código",
            anteprima: "Vista previa",
            items: [
                { name: "TRÁFICO", example: "Estacionamiento · Límites de velocidad · Móvil al volante" },
                { name: "CIVIL", example: "Daños · Lindes · Controversias contractuales" },
                { name: "PENAL", example: "Delitos contra el patrimonio · Orden público · Persona" },
                { name: "DEPORTIVO", example: "Reglamentos federales · Fair play · Infracciones en cancha" },
            ],
        },
        testimonials: {
            eyebrow: "Voces",
            count: "Quién la está probando",
            quotes: [
                { text: "Una herramienta indispensable para quien quiere conocer de verdad las reglas de su ciudad.", author: "Marco V.", role: "Conductor, 42" },
                { text: "Sentinel convierte a cada ciudadano en un custodio activo y consciente de la legalidad.", author: "Elena M.", role: "Abogada civilista, 55" },
                { text: "En cancha lo uso para captar al instante la gravedad de las faltas. Un vistazo y el reglamento queda claro.", author: "Luca R.", role: "Árbitro amateur, 27" },
            ],
        },
        faq: {
            eyebrow: "FAQ",
            count: "Preguntas frecuentes",
            headline_a: "Tus",
            headline_b: "preguntas",
            headline_c: ", sin rodeos.",
            items: [
                { q: "¿La app sustituye a un abogado?", a: "No. Sentinel es una herramienta de conciencia cívica y estimación preliminar. No ofrece asesoría legal oficial, pero te ayuda a entender qué norma pudo haberse violado y el orden de magnitud de las sanciones." },
                { q: "¿Cómo se calculan las sanciones?", a: "La IA cruza los datos de la infracción denunciada con los códigos vigentes (Tráfico, Civil, Penal, Deportivo) y con la jurisdicción local del municipio en el que estás." },
                { q: "¿Mis datos son privados?", a: "Absolutamente. Las denuncias se procesan garantizando el anonimato del usuario y la privacidad by design. Ningún dato personal se comparte sin consentimiento." },
                { q: "¿Cuándo estará disponible Sentinel?", a: "Estamos terminando las últimas funciones. Únete a la lista de espera para ser de los primeros en probarla en iOS y Android." },
                { q: "¿La app es gratuita?", a: "Las funciones básicas para el ciudadano siempre serán gratuitas. Se evalúan herramientas avanzadas (informes detallados, exportación) como opción premium." },
            ],
        },
        finalCta: {
            eyebrow: "Lista de espera · Coming Soon",
            headline_a: "Conviértete en un",
            headline_b: "Centinela.",
            body: "Serás de los primeros en probar Sentinel. Sin spam, solo un email cuando estemos listos para el lanzamiento.",
            placeholder: "Tu dirección de email",
            submit: "Suscribirme",
            submitting: "Espera…",
            successTitle: "Estás en la lista de espera.",
            successBody: "Te escribiremos en cuanto Sentinel esté listo. Bienvenido/a a los Centinelas.",
            errorInvalid: "Introduce un email válido.",
            liveInfo: "Vista previa disponible Q1",
            stores: "iOS & Android · Coming Soon",
            noCard: "Sin tarjeta requerida",
        },
        footer: {
            tagline: "The Good Big Brother is You",
            about: "El asistente cívico inteligente. Observa, analiza, estima. Una red para el ciudadano consciente, por un país más justo.",
            navigate: "Navega",
            coming: "Próximamente disponible",
            comingSoon: "Coming Soon",
            rights: "© 2026 Sentinel — Todos los derechos reservados.",
            made: "Made in Italy · Ética by design",
            top: "Volver arriba ↑",
        },
    },

    fr: {
        nav: {
            manifesto: "Manifeste",
            rete: "Le Réseau",
            comeFunziona: "Comment ça marche",
            codici: "Codes",
            faq: "FAQ",
            cta: "Liste d'attente",
            language: "Langue",
        },
        hero: {
            eyebrow: "Le réseau civique intelligent",
            headline_1: "The Good",
            headline_2a: "Big",
            headline_2b: "Brother",
            headline_3a: "is",
            headline_3b: "You.",
            subtitle:
                "Le premier réseau social civique. Signale, soutiens, repartage. Une IA estime la norme violée et les dommages ; tu es notifié quand ça se passe près de toi. Chaque contribution vérifiée te fait monter de niveau.",
            ctaPrimary: "Rejoindre la liste d'attente",
            ctaSecondary: "Voir comment ça marche",
            liveNorm: "LIVE — Normes à jour",
            comingStores: "Coming Soon · iOS & Android",
            scroll: "Défiler",
            target: "+ Cible",
            shieldId: "SHIELD 001",
        },
        trust: {
            label: "Un réseau civique, une seule app —",
            items: ["Feed live", "IA · Estimation dommages", "Alertes géo", "Score & niveaux", "Codes en vigueur"],
        },
        marquee: ["Le bon citoyen", "c'est le réseau", "The good big brother is you", "Sentinel"],
        manifesto: {
            eyebrow: "Manifeste",
            count: "Six principes",
            chapterLabel: "Chapitre",
            chapters: [
                { title: "Observe", text: "Chaque citoyen est le premier gardien du territoire. Reconnais une infraction et prends conscience de l'espace autour de toi." },
                { title: "Signale", text: "Photo, vidéo, GPS : ton signalement entre dans un feed live, visible par tout le réseau civique." },
                { title: "Analyse", text: "L'IA de Sentinel identifie la règle précise enfreinte et estime automatiquement les dommages économiques." },
                { title: "Partage", text: "La communauté discute, soutient et repartage. La responsabilité civique devient collective." },
                { title: "Grandis", text: "Chaque contribution vérifiée te fait monter de niveau : d'Observateur à Gardien, jusqu'à Sentinelle." },
                { title: "Éduque", text: "Ce n'est pas une dystopie, c'est de la responsabilité. Vigilance éthique par le bas, transparente et guidée par les citoyens." },
            ],
        },
        civic: {
            eyebrow: "Le Réseau",
            tagline: "Social · Civique · Vérifié",
            headline_a: "Pas une app. Un",
            headline_b: "réseau",
            headline_c: "de responsabilité civile.",
            body_a: "Sentinel est le premier",
            body_b: "réseau social civique",
            body_c: " : un feed live où les citoyens signalent, soutiennent et discutent de ce qui se passe sur leur territoire. Tu reçois",
            body_d: "des alertes géographiques",
            body_e: "quand il se passe quelque chose près de toi. Chaque contribution vérifiée te fait grandir — de l'Observateur à la",
            body_f: "Sentinelle",
            levelsTitle: "Les niveaux du réseau",
            stats: [
                { k: "Soutiens", v: "1.2k" },
                { k: "Débats", v: "384" },
                { k: "Repartages", v: "526" },
                { k: "Alertes géo", v: "12/h" },
            ],
            levels: [
                { n: "Lv1", title: "Observateur", desc: "Tes premiers yeux sur le territoire." },
                { n: "Lv2", title: "Citoyen", desc: "Signalements vérifiés par la communauté." },
                { n: "Lv3", title: "Gardien du quartier", desc: "Contributions régulières et retours précis." },
                { n: "Lv4", title: "Gardien", desc: "Référence du quartier." },
                { n: "Lv5", title: "Sentinelle", desc: "Autorité civique reconnue par le réseau." },
            ],
            floatNotifTitle: "Nouveau près de toi",
            floatNotifText: "Stationnement interdit · 120m",
            floatNotifLoc: "Rome · Trastevere",
            floatAiTitle: "Analyse IA terminée",
            floatAiBadge: "+ 12 pts · Lv4 Gardien",
        },
        how: {
            eyebrow: "Le flux",
            count: "Trois étapes",
            headline_a: "Comment fonctionne",
            headline_b: "Sentinel",
            stepLabel: "Étape",
            steps: [
                { title: "Signale", text: "Photo ou vidéo avec GPS. Catégorie, lieu, description — le tout en quelques secondes." },
                { title: "L'IA analyse", text: "L'intelligence artificielle identifie la règle exacte et estime les dommages." },
                { title: "Entre dans le feed", text: "La communauté discute, soutient et repartage. Tu gagnes des points et montes de niveau." },
            ],
        },
        features: {
            eyebrow: "Fonctionnalités",
            count: "Huit piliers",
            headline_a: "Un outil",
            headline_b: "complet",
            items: [
                { title: "Signaler une infraction", text: "Photo, vidéo, GPS en un tap. Ton signalement entre directement dans le réseau civique." },
                { title: "IA · Norme & Dommages", text: "L'IA identifie la règle enfreinte et estime le dommage économique." },
                { title: "Alertes près de toi", text: "Nous te prévenons en temps réel quand quelque chose se passe dans ton quartier." },
                { title: "Réseau social civique", text: "Un feed citoyen : commente, soutiens, repartage. La responsabilité est collective." },
                { title: "Score & Niveaux", text: "Chaque contribution vérifiée te fait grandir : d'Observateur à Gardien, à Sentinelle." },
                { title: "Catégories multiples", text: "Trafic, Environnement, Décorum urbain, Sport, Civil, Pénal — un seul feed." },
                { title: "Géo-normatif", text: "Les règles s'adaptent au lieu exact du signalement." },
                { title: "Portefeuille civique", text: "Échange les points gagnés avec la communauté. De la vraie reconnaissance." },
            ],
        },
        coverage: {
            eyebrow: "Couverture",
            count: "Quatre codes",
            headline_a: "Une app pour",
            headline_b: "chaque norme",
            previewLabel: "Code",
            anteprima: "Aperçu",
            items: [
                { name: "ROUTIER", example: "Stationnement · Limites de vitesse · Téléphone au volant" },
                { name: "CIVIL", example: "Dommages · Limites · Litiges contractuels" },
                { name: "PÉNAL", example: "Atteintes au patrimoine · Ordre public · Personne" },
                { name: "SPORTIF", example: "Règlements fédéraux · Fair play · Infractions sur le terrain" },
            ],
        },
        testimonials: {
            eyebrow: "Voix",
            count: "Qui la teste",
            quotes: [
                { text: "Un outil indispensable pour qui veut vraiment connaître les règles de sa ville.", author: "Marco V.", role: "Automobiliste, 42" },
                { text: "Sentinel transforme chaque citoyen en un gardien actif et conscient de la légalité.", author: "Elena M.", role: "Avocate civiliste, 55" },
                { text: "Sur le terrain je l'utilise pour saisir aussitôt la gravité des fautes. Un coup d'œil et le règlement est clair.", author: "Luca R.", role: "Arbitre amateur, 27" },
            ],
        },
        faq: {
            eyebrow: "FAQ",
            count: "Questions fréquentes",
            headline_a: "Tes",
            headline_b: "questions",
            headline_c: ", sans détour.",
            items: [
                { q: "L'app remplace-t-elle un avocat ?", a: "Non. Sentinel est un outil de conscience civique et d'estimation préliminaire. Elle ne fournit pas de conseil juridique officiel, mais t'aide à comprendre quelle règle a pu être enfreinte et l'ordre de grandeur des sanctions." },
                { q: "Comment les sanctions sont-elles calculées ?", a: "L'IA croise les données de l'infraction signalée avec les codes en vigueur (Routier, Civil, Pénal, Sportif) et la juridiction locale de la commune." },
                { q: "Mes données sont-elles privées ?", a: "Absolument. Les signalements sont traités en garantissant l'anonymat de l'utilisateur et la privacy by design. Aucune donnée personnelle n'est partagée sans consentement." },
                { q: "Quand Sentinel sera-t-elle disponible ?", a: "Nous finalisons les dernières fonctionnalités. Rejoins la liste d'attente pour être parmi les premiers à l'essayer sur iOS et Android." },
                { q: "L'app est-elle gratuite ?", a: "Les fonctions de base pour le citoyen seront toujours gratuites. Des outils avancés (rapports détaillés, export) sont à l'étude en option premium." },
            ],
        },
        finalCta: {
            eyebrow: "Liste d'attente · Coming Soon",
            headline_a: "Deviens une",
            headline_b: "Sentinelle.",
            body: "Tu seras parmi les premiers à essayer Sentinel. Pas de spam, un seul email quand nous serons prêts.",
            placeholder: "Ton adresse email",
            submit: "S'inscrire",
            submitting: "Patiente…",
            successTitle: "Tu es sur la liste d'attente.",
            successBody: "Nous t'écrirons dès que Sentinel sera prêt. Bienvenue parmi les Sentinelles.",
            errorInvalid: "Saisis un email valide.",
            liveInfo: "Aperçu disponible Q1",
            stores: "iOS & Android · Coming Soon",
            noCard: "Sans carte",
        },
        footer: {
            tagline: "The Good Big Brother is You",
            about: "L'assistant civique intelligent. Observer, analyser, estimer. Un réseau pour le citoyen conscient, pour un pays plus juste.",
            navigate: "Naviguer",
            coming: "Bientôt disponible",
            comingSoon: "Coming Soon",
            rights: "© 2026 Sentinel — Tous droits réservés.",
            made: "Made in Italy · Éthique by design",
            top: "Retour en haut ↑",
        },
    },

    de: {
        nav: {
            manifesto: "Manifest",
            rete: "Das Netzwerk",
            comeFunziona: "Wie es funktioniert",
            codici: "Gesetze",
            faq: "FAQ",
            cta: "Warteliste",
            language: "Sprache",
        },
        hero: {
            eyebrow: "Das intelligente Bürger-Netzwerk",
            headline_1: "The Good",
            headline_2a: "Big",
            headline_2b: "Brother",
            headline_3a: "is",
            headline_3b: "You.",
            subtitle:
                "Das erste zivile soziale Netzwerk. Melden, unterstützen, teilen. Eine KI schätzt den verletzten Paragrafen und die Schäden; du wirst benachrichtigt, wenn etwas in deiner Nähe passiert. Jeder verifizierte Beitrag lässt dich aufsteigen.",
            ctaPrimary: "Der Warteliste beitreten",
            ctaSecondary: "So funktioniert es",
            liveNorm: "LIVE — Aktuelle Gesetze",
            comingStores: "Coming Soon · iOS & Android",
            scroll: "Scrollen",
            target: "+ Ziel",
            shieldId: "SHIELD 001",
        },
        trust: {
            label: "Ein Bürger-Netzwerk, eine App —",
            items: ["Live-Feed", "KI · Schadensschätzung", "Geo-Meldungen", "Punkte & Level", "Gültige Gesetze"],
        },
        marquee: ["Der gute Bürger", "ist das Netzwerk", "The good big brother is you", "Sentinel"],
        manifesto: {
            eyebrow: "Manifest",
            count: "Sechs Prinzipien",
            chapterLabel: "Kapitel",
            chapters: [
                { title: "Beobachten", text: "Jeder Bürger ist der erste Wächter des Territoriums. Erkenne eine Übertretung und werde dir des Raums um dich bewusst." },
                { title: "Melden", text: "Foto, Video, GPS: Deine Meldung erscheint in einem Live-Feed, sichtbar für das gesamte Bürgernetzwerk." },
                { title: "Analysieren", text: "Sentinels KI identifiziert die verletzte Regel und schätzt automatisch den wirtschaftlichen Schaden." },
                { title: "Teilen", text: "Die Community diskutiert, unterstützt und teilt. Bürgerverantwortung wird kollektiv." },
                { title: "Wachsen", text: "Jeder verifizierte Beitrag lässt dich aufsteigen: vom Beobachter zum Wächter, bis zur Schildwache." },
                { title: "Bilden", text: "Keine Dystopie, sondern Verantwortung. Ethische Kontrolle von unten, transparent und von den Bürgern geführt." },
            ],
        },
        civic: {
            eyebrow: "Das Netzwerk",
            tagline: "Sozial · Zivil · Verifiziert",
            headline_a: "Keine App. Ein",
            headline_b: "Netzwerk",
            headline_c: "der Bürgerverantwortung.",
            body_a: "Sentinel ist das erste",
            body_b: "zivile soziale Netzwerk",
            body_c: ": ein Live-Feed, in dem Bürger melden, unterstützen und diskutieren, was in ihrem Territorium passiert. Du erhältst",
            body_d: "geografische Benachrichtigungen",
            body_e: "wenn etwas in deiner Nähe passiert. Jeder verifizierte Beitrag lässt dich aufsteigen — vom Beobachter zur",
            body_f: "Schildwache",
            levelsTitle: "Die Level des Netzwerks",
            stats: [
                { k: "Unterstützer", v: "1.2k" },
                { k: "Diskussionen", v: "384" },
                { k: "Geteilt", v: "526" },
                { k: "Geo-Alerts", v: "12/h" },
            ],
            levels: [
                { n: "Lv1", title: "Beobachter", desc: "Deine ersten Augen im Territorium." },
                { n: "Lv2", title: "Bürger", desc: "Von der Community verifizierte Meldungen." },
                { n: "Lv3", title: "Hüter", desc: "Regelmäßige Beiträge, präzises Feedback." },
                { n: "Lv4", title: "Wächter", desc: "Bezugspunkt im Viertel." },
                { n: "Lv5", title: "Schildwache", desc: "Vom Netzwerk anerkannte Bürgerautorität." },
            ],
            floatNotifTitle: "Neu in deiner Nähe",
            floatNotifText: "Parkverbot · 120m",
            floatNotifLoc: "Rom · Trastevere",
            floatAiTitle: "KI-Analyse abgeschlossen",
            floatAiBadge: "+ 12 Pkt. · Lv4 Wächter",
        },
        how: {
            eyebrow: "Der Ablauf",
            count: "Drei Schritte",
            headline_a: "Wie",
            headline_b: "Sentinel funktioniert",
            stepLabel: "Schritt",
            steps: [
                { title: "Melden", text: "Foto oder Video mit GPS. Kategorie, Ort, Beschreibung — alles in Sekunden." },
                { title: "KI analysiert", text: "Die KI identifiziert die genaue Regel und schätzt den wirtschaftlichen Schaden." },
                { title: "In den Feed", text: "Die Community diskutiert, unterstützt, teilt. Du verdienst Punkte und steigst auf." },
            ],
        },
        features: {
            eyebrow: "Funktionen",
            count: "Acht Säulen",
            headline_a: "Ein vollständiges",
            headline_b: "Werkzeug",
            items: [
                { title: "Übertretung melden", text: "Foto, Video, GPS in einem Tap. Deine Meldung erreicht sofort das Netzwerk." },
                { title: "KI · Regel & Schaden", text: "Die KI erkennt die verletzte Regel und schätzt den wirtschaftlichen Schaden." },
                { title: "Alerts in der Nähe", text: "Wir benachrichtigen dich in Echtzeit, wenn etwas in deinem Viertel passiert." },
                { title: "Ziviles soziales Netzwerk", text: "Ein Bürger-Feed: kommentiere, unterstütze, teile. Verantwortung ist kollektiv." },
                { title: "Punkte & Level", text: "Jeder verifizierte Beitrag lässt dich wachsen: vom Beobachter zum Wächter, zur Schildwache." },
                { title: "Mehrere Kategorien", text: "Verkehr, Umwelt, Stadtbild, Sport, Zivil, Strafrecht — ein einziger Feed." },
                { title: "Geo-Recht", text: "Die Regeln passen sich dem exakten Ort der Meldung an." },
                { title: "Bürger-Wallet", text: "Löse gesammelte Punkte mit der Community ein. Echte Anerkennung, nicht nur Badges." },
            ],
        },
        coverage: {
            eyebrow: "Abdeckung",
            count: "Vier Gesetzbücher",
            headline_a: "Eine App für",
            headline_b: "jede Norm",
            previewLabel: "Gesetz",
            anteprima: "Vorschau",
            items: [
                { name: "VERKEHR", example: "Parkverbote · Geschwindigkeitslimits · Handy am Steuer" },
                { name: "ZIVIL", example: "Schäden · Grenzen · Vertragsstreitigkeiten" },
                { name: "STRAFRECHT", example: "Vermögensdelikte · Öffentliche Ordnung · Person" },
                { name: "SPORT", example: "Verbandsordnungen · Fair Play · Vergehen auf dem Feld" },
            ],
        },
        testimonials: {
            eyebrow: "Stimmen",
            count: "Wer sie testet",
            quotes: [
                { text: "Ein unverzichtbares Werkzeug für alle, die die Regeln ihrer Stadt wirklich kennen wollen.", author: "Marco V.", role: "Autofahrer, 42" },
                { text: "Sentinel macht jeden Bürger zu einem aktiven, bewussten Hüter der Legalität.", author: "Elena M.", role: "Zivilrechtsanwältin, 55" },
                { text: "Auf dem Platz erkenne ich damit sofort die Schwere der Fouls. Ein Blick und die Regeln sind klar.", author: "Luca R.", role: "Amateur-Schiedsrichter, 27" },
            ],
        },
        faq: {
            eyebrow: "FAQ",
            count: "Häufige Fragen",
            headline_a: "Deine",
            headline_b: "Fragen",
            headline_c: ", direkt beantwortet.",
            items: [
                { q: "Ersetzt die App einen Anwalt?", a: "Nein. Sentinel ist ein Werkzeug für Bürgerbewusstsein und Voreinschätzung. Sie bietet keine offizielle Rechtsberatung, sondern hilft dir zu verstehen, welche Regel verletzt sein könnte und in welcher Größenordnung Sanktionen liegen." },
                { q: "Wie werden Sanktionen berechnet?", a: "Die KI verknüpft die gemeldeten Daten mit den geltenden Gesetzen (Verkehr, Zivil, Strafrecht, Sport) und der lokalen Zuständigkeit deiner Gemeinde." },
                { q: "Sind meine Daten privat?", a: "Absolut. Meldungen werden unter Wahrung von Anonymität und Privacy by Design verarbeitet. Keine persönlichen Daten werden ohne Zustimmung geteilt." },
                { q: "Wann wird Sentinel verfügbar sein?", a: "Wir stellen die letzten Funktionen fertig. Trage dich in die Warteliste ein, um zu den Ersten zu gehören, die sie auf iOS und Android testen." },
                { q: "Ist die App kostenlos?", a: "Die Basisfunktionen für Bürger bleiben immer kostenlos. Erweiterte Werkzeuge (detaillierte Berichte, Export) werden als Premium-Option geprüft." },
            ],
        },
        finalCta: {
            eyebrow: "Warteliste · Coming Soon",
            headline_a: "Werde eine",
            headline_b: "Schildwache.",
            body: "Sei unter den Ersten, die Sentinel testen. Kein Spam, nur eine einzige E-Mail zum Start.",
            placeholder: "Deine E-Mail-Adresse",
            submit: "Anmelden",
            submitting: "Bitte warten…",
            successTitle: "Du bist auf der Warteliste.",
            successBody: "Wir schreiben dir, sobald Sentinel bereit ist. Willkommen bei den Schildwachen.",
            errorInvalid: "Bitte gib eine gültige E-Mail ein.",
            liveInfo: "Vorschau verfügbar Q1",
            stores: "iOS & Android · Coming Soon",
            noCard: "Keine Karte nötig",
        },
        footer: {
            tagline: "The Good Big Brother is You",
            about: "Der intelligente Bürger-Assistent. Beobachten, analysieren, schätzen. Ein Netzwerk für den bewussten Bürger — für ein gerechteres Land.",
            navigate: "Navigation",
            coming: "Bald verfügbar",
            comingSoon: "Coming Soon",
            rights: "© 2026 Sentinel — Alle Rechte vorbehalten.",
            made: "Made in Italy · Ethik by design",
            top: "Nach oben ↑",
        },
    },
};
